











import { Component, Vue } from 'vue-property-decorator'

import { db } from '@/database'

// Types
// import { MatchConfig } from 'match-central-shared/dist/types/match-config'

// Views
import MainLayout from '@/views/layout/Main.vue'

const SPORTS_OPTIONS: readonly string[] = []

const DEFAULT_FORM = Object.freeze({
  kickoff: {
    date: new Date().toISOString().substr(0, 10),
    time: '',
  },

  hName: '',
  hAbbr: '',

  vName: '',
  vAbbr: '',

  sport: SPORTS_OPTIONS[0],
})

@Component({
  components: {
    MainLayout,
  },
})
export default class MatchConfigPresets extends Vue {
  kickoffTimePicker = false
  kickoffDatePicker = false

  loading = false

  form = Object.assign({}, DEFAULT_FORM)

  sportsOptions: string[] = Object.assign([], SPORTS_OPTIONS)

  get validate(): boolean {
    const f = this.form

    // Team names
    if (f.hName.length < 2) {
      return false
    }
    if (f.vName.length < 2) {
      return false
    }

    // Team abbreviations
    // if (f.hAbbr.length < 2) {
    //   return false
    // }
    // if (f.vAbbr.length < 2) {
    //   return false
    // }

    // Guard no Sport selected
    if (!f.sport) {
      return false
    }

    return true
  }

  save(): void {
    console.log('Save preset')

    const t = true

    if (t) {
      return
    }

    const preset = {}

    db.collection('match_configuration_presets')
      .add(preset)
      .then((response: unknown) => {
        console.log('Saved match configuration preset! Firestore response:', response)

        this.resetForm()
      })
      .catch((err: unknown) => {
        console.error('Error saving match! Firestore err:', err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  resetForm(): void {
    this.form = Object.assign({}, DEFAULT_FORM)
  }
}
